var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsUp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 19.501v-15a.5.5 0 1 1 1 0v15a.5.5 0 0 1-1 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.724 4.082a.5.5 0 0 1 .628.065l5.002 5 .064.079a.5.5 0 0 1-.772.629L12 5.207 7.352 9.855a.5.5 0 1 1-.708-.707l5.002-5.001z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsUp);
export default ForwardRef;